var _rect, _path, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.0459,
    height: 22.0459,
    rx: 2.18918,
    fill: "#FFC814"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.33287C4 5.47378 4.69643 4.77734 5.55553 4.77734H16.8331C17.0479 4.77734 17.222 4.95145 17.222 5.16623V6.33287C17.222 7.19197 16.5256 7.8884 15.6665 7.8884H5.55553C4.69643 7.8884 4 7.19197 4 6.33287Z",
    fill: "#383538"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.1107V6.33301C4 7.1921 4.69643 7.88854 5.55553 7.88854H16.4442C17.3033 7.88854 17.9998 8.58497 17.9998 9.44406V11.6607C17.9998 11.7251 17.9475 11.7774 17.8831 11.7774H15.6665C14.8074 11.7774 14.1109 12.4738 14.1109 13.3329C14.1109 14.192 14.8074 14.8884 15.6665 14.8884H17.8831C17.9475 14.8884 17.9998 14.9406 17.9998 15.0051V15.6662C17.9998 16.5253 17.3033 17.2217 16.4442 17.2217H7.11106C5.39287 17.2217 4 15.8288 4 14.1107Z",
    fill: "#0096FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 13.3334C13.333 12.4743 14.0294 11.7779 14.8885 11.7779H17.8829C17.9474 11.7779 17.9996 11.8301 17.9996 11.8945V14.7723C17.9996 14.8367 17.9474 14.8889 17.8829 14.8889H14.8885C14.0294 14.8889 13.333 14.1925 13.333 13.3334Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.55566,
    y: 9.44434,
    width: 4.66658,
    height: 0.777764,
    rx: 0.388882,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.c5ba0ce0b9325d3dc41fea7054624c5b.svg";
export { ForwardRef as ReactComponent };